export default __webpack_public_path__ + "static/media/img-economic-calendar.b463d078.png";